/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import classnames from 'classnames';
import { IFullOrgUnitAvailability } from '../common/full-org-unit-availability';
import { IFarmlandsStoreSelectorResources, ITermsOfServiceLinkData } from '../farmlands-store-selector.props.autogenerated';

export interface IStoreSelectorEmptyMessageProps {
    resources: IFarmlandsStoreSelectorResources;
}
export const StoreSelectorEmptyMessage: React.FC<IStoreSelectorEmptyMessageProps> = ({ resources }) => (
    <div className='ms-store-select__no-locations'>
        <p>{resources.emptyLocationsText}</p>
    </div>
);

export const StoreSelectorWaiting: React.FC = () => (
    <div className={classnames('msc-waiting-circular', 'ms-store-select__search-in-progress')} />
);

export interface IStoreSelectorTermsOfServiceProps {
    link?: ITermsOfServiceLinkData;
}
export const StoreSelectorTermsOfService: React.FC<IStoreSelectorTermsOfServiceProps> = ({ link }) => (
    <div className='ms-store-select__footer'>
        {link ?
            <a
                className='ms-store-select__terms-link'
                role='button'
                title={link.linkText}
                href={link.linkUrl && link.linkUrl.destinationUrl}
                aria-label={link.ariaLabel}
                target={link.openInNewTab ? '_blank' : undefined}
            >
                {link.linkText}
            </a> :
            null
        }
    </div>
);

export interface IStoreSelectorFoundLocationsMessage {
    resources: IFarmlandsStoreSelectorResources;
    locations?: IFullOrgUnitAvailability[];
    searchRadius: number;
}
export const StoreSelectorFoundLocationsMessage: React.FC<IStoreSelectorFoundLocationsMessage> = ({ locations, searchRadius, resources }) => {
    if (locations) {
        return (
            <div className='ms-store-select__found-locations'>
                {resources.storeCountMessage
                    .replace('{count}', locations.length.toString())
                    .replace('{radius}', searchRadius.toString())}
            </div>
        );
    }

    return null;
};